import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-avacon-storungen',
  templateUrl: './avacon-storungen.component.html',
  styleUrls: ['./avacon-storungen.component.scss'],
})
export class AvaconStorungenComponent {
  @Input() url!: string;
  @Input() isIE11 = false;
  faultCardLink = 'https://assp2.supinfo.de/fisxp/public/psi/extern.aspx';
  videoLink = 'https://www.youtube.com/watch?time_continue=32&v=cYHRxUar4Nk&feature=emb_title';

  isCollapsed = false;

  constructor(private _router: Router) {}

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  gotoDashboard() {
    this._router.navigateByUrl('/instrumententafel');
  }
}
